import { render } from "./SubpageGiftcards.vue?vue&type=template&id=eee184da"
import script from "./SubpageGiftcards.vue?vue&type=script&lang=js"
export * from "./SubpageGiftcards.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__